export default __webpack_public_path__ + "static/media/pass_person.bcbeb62a.png";